import { HOME_BODY_COLOR, LIGHT_GREEN } from "styles/oneOffColor";

const styles = {
  iconBlock: {
    fontSize: 20,
    backgroundColor: HOME_BODY_COLOR,
    borderRadius: 2,
    width: 35,
    height: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    p: 1,
    mr: 3,
  },
  annotationPrice: {
    fontSize: 10,
    textTransform: "none",
    color: "primary.main",
    ml: 1,
    backgroundColor: LIGHT_GREEN,
    borderRadius: 4,
    px: 2,
    py: 0.5,
    width: "fit-content",
  },
};

export default styles;
